import { EMediaQuery } from 'src/styles/theme/utils/enums';
import { mq } from 'src/styles/theme/utils/functions';
import styled from 'styled-components';

export const StyledAvatar = styled.div`
	position: relative;
	width: 120px;
	height: 120px;
	border-radius: 50%;
	background-color: transparent;
	overflow: hidden;
	flex-shrink: 0;

	${mq(
		EMediaQuery.lg,
		`
		width: 100px;
		height: 100px;
		`
	)}

	${mq(
		EMediaQuery.md,
		`
		width: 90px;
		height: 90px;
		`
	)}
	${mq(
		EMediaQuery.sm,
		`
			width: 60px;
			height: 60px;
		`
	)}
`;
